import { useState } from 'react';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';
import CustodianAgreementInterface from '@api/requests/applications/interfaces/CustodianAgreementInterface.interface';

import { showToast } from '@app/providers/ToastProvider';

function useCustodianAgreements(applicationId: number) {
	const [agreeingId, setAgreeingId] = useState<number | null>(null);

	const { startRequest: agreeCustodianAgreement } = useTriggeredRequest(
		AccountClientRequests.Applications.agreeCustodianAgreement,
	);

	const { startRequest: refetchApplicationDetails } = useTriggeredRequest(
		AccountClientRequests.Applications.getApplicationDetails,
	);

	const handleAgree = async (
		agreement: CustodianAgreementInterface,
		isLastRequiredAgreement: boolean,
	): Promise<boolean> => {
		setAgreeingId(agreement.id);

		try {
			await agreeCustodianAgreement({
				application_id: applicationId,
				custodian_agreement_id: agreement.id,
			});

			if (isLastRequiredAgreement) {
				await refetchApplicationDetails({ application_id: applicationId });
			}

			return true;
		} catch (e) {
			showToast.error('Something went wrong!');

			return false;
		} finally {
			setAgreeingId(null);
		}
	};

	return {
		handleAgree,
		agreeingId,
		isAgreeing: agreeingId !== null,
	};
}

export default useCustodianAgreements;
